import { useField } from 'formik';
import React from 'react';
import { SelectBlock } from './SelectBlock';
import { Props } from './SelectBlock';

interface FormProps {
    name: string;
}

export const FormSelectBlock: React.FC<
    FormProps & Omit<Props, 'value' | 'onChange'>
> = ({ name, ...props }) => {
    const [field, , helpers] = useField(name);
    return (
        <SelectBlock
            {...props}
            value={field.value}
            onChange={helpers.setValue}
        />
    );
};
